/* eslint-disable */
// AUTO-GENERATED by scripts/codegen/generate.mjs from wix.isa.file_system.v1 — do not edit.

import { resolveUrl, toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
const _getFileSystemRequest = {};
const _fileSystem = {
  createdDate: 'google.protobuf.Timestamp',
  updatedDate: 'google.protobuf.Timestamp'
};
const _getFileSystemResponse = {
  fileSystem: '_fileSystem'
};
const _updateFileSystemRequest = {
  fileSystem: '_fileSystem',
  fieldMask: 'google.protobuf.FieldMask'
};
const _updateFileSystemResponse = {
  fileSystem: '_fileSystem'
};
const _descriptors = {
  _getFileSystemRequest,
  _fileSystem,
  _getFileSystemResponse,
  _updateFileSystemRequest,
  _updateFileSystemResponse
};
function resolveFileSystemServiceUrl(opts) {
  const domainToMappings = {
    'manage._base_domain_': [{
      srcPath: '/_api/file-system',
      destPath: ''
    }],
    'chat.nownia.com': [{
      srcPath: '/_api/file-system',
      destPath: ''
    }],
    'apps.nownia.com': [{
      srcPath: '/_api/file-system',
      destPath: ''
    }]
  };
  return resolveUrl(Object.assign(opts, {
    domainToMappings
  }));
}

/** GetFileSystem. */
export function getFileSystem(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_getFileSystemRequest, _descriptors);
  const fromRes = serializer(_getFileSystemResponse, _descriptors).fromJSON;
  function __getFileSystem(_ref) {
    let {
      host
    } = _ref;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.file_system',
      method: 'GET',
      methodFqn: 'wix.isa.file_system.v1.FileSystemService.GetFileSystem',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveFileSystemServiceUrl({
        protoPath: '/v1/file-system',
        data: serializedData,
        host
      }),
      params: toURLSearchParams(serializedData, true),
      transformResponse: fromRes
    };
  }
  __getFileSystem.fromReq = fromReq;
  __getFileSystem.__isAmbassador = true;
  return __getFileSystem;
}

/** Updates the FileSystem. */
export function updateFileSystem(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_updateFileSystemRequest, _descriptors);
  const fromRes = serializer(_updateFileSystemResponse, _descriptors).fromJSON;
  function __updateFileSystem(_ref2) {
    let {
      host
    } = _ref2;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.file_system',
      method: 'PATCH',
      methodFqn: 'wix.isa.file_system.v1.FileSystemService.UpdateFileSystem',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveFileSystemServiceUrl({
        protoPath: '/v1/file-system',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __updateFileSystem.fromReq = fromReq;
  __updateFileSystem.__isAmbassador = true;
  return __updateFileSystem;
}
//# sourceMappingURL=fileSystemHttpRequests.js.map